@if (!isComponentLoading) {
<div id="dx-disclosures" class="bl-margin-bottom--40">
  <ea-accordion-group #disclosuresGroup [(accordionGroupMeta)]="accordionGroupMeta">
    @for (disclosure of disclosures; track disclosure.id || $index; let i = $index; let last = $last) {
    <div id="disclosure-card-{{ i }}" class="bl-padding-y--16" [class.bl-border-bottom]="!last">
      <ea-accordion
        #disclosureRef
        [defaultExpanded]="disclosure.isOpen == true"
        controllerPosition="above"
        [controllerInnerHtml]="disclosureTitleHtml(disclosure)"
        controllerClass="bl-display--flex bl-width--100 bl-font-color--base"
        [controllerAriaLabel]="'Accordion ' +  disclosure.title"
        class="bl-width--100"
        uniqueId="disclosure-{{ i }}"
      >
        <!-- Content section -->
        <div data-automation-id="review-disclosure-wrapper" class="bl-margin-top--8">
          <!-- Common header for all content types -->
          @if (disclosure.isPDFFile || disclosure.isHtmlFile || (!disclosure.isPDFFile && !disclosure.isHtmlFile)) {
          <div class="bl-display--flex bl-justify-content--flex-end">
            <!-- Action button -->
             @if (getDisclosurePdfUrl(i)) {
            <button 
              (click)="openDisclosurePDFInNewTab(i)" 
              id="open-disclosure-{{ i }}" 
              [attr.data-automation-id]="'open-disclosure-pdf-' + i"
              class="bl-text-style--tertiary-text-2"
              eaTooltip="Open this PDF in a new tab to view, download or print.">
              <span class="bl-font-color--blue bl-display--flex bl-align-items--center">
                <i class="cu-external-link bl-padding-right--8" alt="" aria-hidden="true"></i>
                Open in new tab
              </span>
            </button>
            }
          </div>
          }
          
          <!-- Content display -->
          @if (!disclosure.isPDFFile && !disclosure.isHtmlFile) {
            <div data-automation-id="review-text-disclosure" class="dx-disclosure-content" [innerHTML]="this.utilitiesService.normalizeSpaces(disclosure.content | safe : 'html')"></div>
          } @else if (disclosureContentMap[i]) {
            @if (getDisclosurePdfUrl(i)) {
              <ea-pdf-embed [pdfSrc]="getDisclosurePdfUrl(i)"></ea-pdf-embed>
            } @else if (getDisclosureContent(i)) {
              <div [innerHTML]="getDisclosureContent(i)"></div>
            }
          } @else {
            <div class="bl-margin-bottom--16 bl-font-color--secondary">Content loading...</div>
          }
        </div>

        @if (disclosure.isLinkType) {
        <div class="bl-margin-bottom--16">
          <a
            [href]="disclosure.url"
            class="button-anchor"
            [attr.data-automation-id]="'disclosure-external-link-' + i"
            target="_blank"
            (click)="chkSelection(disclosure, disclosureRef, disclosuresGroup)"
            >{{ disclosure.urlDisplayText }}</a>
        </div>
        }

        @if (isArray(disclosure.applicants)) {
          @for (applicant of disclosure.applicants; track applicant.storageId || $index; let index = $index) {
            <div
              class="bl-display--flex bl-margin-bottom--16 bl-width--100 bl-flex-flow--wrap"
              [ngClass]="disclosure.applicants.length - 1 != index ? 'bl-padding-right--32' : ''"
            >
              <!-- Error messages -->
              @if (isOlaFlow || isOAOFlow) {
                @if ((!applicant.accepted && (getAllowToAccept(disclosure) == true || disclosure.isPDFFile)) || (hasLink(disclosure) && getAllowToAccept(disclosure) !== true)) {
                  @if ((pageSubmitted$ | async)) {
                  <div class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16" aria-label="error" aria-live="assertive">
                    @if (!applicant.accepted && (getAllowToAccept(disclosure) == true || disclosure.isPDFFile)) {
                      {{ getApplicantLabel(applicant.applicant) }} {{ 'disclosureReview/initialMsg' | dictionary }} {{ disclosure.title }}{{ 'disclosureReview/errorMessage' | dictionary }}
                    } @else {
                      {{ 'disclosureReview/errorDisclosureMsg' | dictionary }}
                    }
                  </div>
                  }
                }
              }

              <div class="bl-check-wrap bl-required">
                <input
                  type="checkbox"
                  id="disclosure_acc_{{ i }}_{{ index }}"
                  [attr.data-automation-id]="'disclosure-checkbox-' + i + '-' + index"
                  #name="ngModel"
                  [(ngModel)]="applicant.accepted"
                  (change)="updateAcceptance(disclosure.applicants, index, disclosureRef, disclosuresGroup); keepCheckboxFocus(i + '_' + index)"
                  required
                  [disabled]="(hasLink(disclosure) && getAllowToAccept(disclosure) !== true) || applicant.disabled"
                />
                <label
                  for="disclosure_acc_{{ i }}_{{ index }}"
                  class="bl-label bl-font-weight--900"
                  [innerHTML]="applicant.label ? getApplicantLabel(applicant.label) : ('disclosureReview/acceptLabel' | dictionary)"
                >
                </label>
              </div>
            </div>
          }
        } @else {
          <div class="bl-display--flex bl-margin-bottom--16 bl-width--100">
            <div class="bl-check-wrap">
              <input
                type="checkbox"
                id="disclosure_{{ i }}"
                [attr.data-automation-id]="'disclosure-checkbox-' + i"
                [checked]="disclosure.accepted"
                (click)="disclosure.accepted = !disclosure.accepted"
                (change)="updateAcceptance(disclosures, i, disclosureRef, disclosuresGroup); keepCheckboxFocus(i)"
                [disabled]="hasLink(disclosure) && getAllowToAccept(disclosure) !== true"
              />
              <label for="disclosure_{{ i }}" class="bl-label bl-font-weight--900">
                {{ 'disclosureReview/acceptLabel' | dictionary }} 
              </label>
            </div>
          </div>
        }
      </ea-accordion>
    </div>
    }
  </ea-accordion-group>
</div>
} @else {
  <ecp-content-spinner [spinnerSmall]="true"></ecp-content-spinner>
}
